__turbopack_context__.v({
  "close": "Lightbox-module-scss-module__fwuEaq__close",
  "closeGroup": "Lightbox-module-scss-module__fwuEaq__closeGroup",
  "counter": "Lightbox-module-scss-module__fwuEaq__counter",
  "escHint": "Lightbox-module-scss-module__fwuEaq__escHint",
  "frame": "Lightbox-module-scss-module__fwuEaq__frame",
  "image": "Lightbox-module-scss-module__fwuEaq__image",
  "lightbox-fade": "Lightbox-module-scss-module__fwuEaq__lightbox-fade",
  "lightbox-fade-out": "Lightbox-module-scss-module__fwuEaq__lightbox-fade-out",
  "lightbox-hint": "Lightbox-module-scss-module__fwuEaq__lightbox-hint",
  "lightbox-in": "Lightbox-module-scss-module__fwuEaq__lightbox-in",
  "lightbox-out": "Lightbox-module-scss-module__fwuEaq__lightbox-out",
  "lightbox-swap": "Lightbox-module-scss-module__fwuEaq__lightbox-swap",
  "overlay": "Lightbox-module-scss-module__fwuEaq__overlay",
  "pager": "Lightbox-module-scss-module__fwuEaq__pager",
  "pagerButton": "Lightbox-module-scss-module__fwuEaq__pagerButton",
  "scroll": "Lightbox-module-scss-module__fwuEaq__scroll",
  "scrollFade": "Lightbox-module-scss-module__fwuEaq__scrollFade",
  "scrollHint": "Lightbox-module-scss-module__fwuEaq__scrollHint",
});
